import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-simple-mat-card',
    templateUrl: './simple-mat-card.component.html',
    styleUrls: ['./simple-mat-card.component.scss'],
    standalone: false
})
export class SimpleMatCardComponent implements OnInit {
  @Input() title: string;

  constructor() {}

  ngOnInit(): void {}
}
